import axios from 'axios'

const hoFacilApiChat = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_WEBSOCKET,
  timeout: 180000 /* 3 minutes */,
  headers: {}

})
export const extractProductFispqInformation = async (body) => {
  try {
    return new Promise((resolve, reject) => {
      hoFacilApiChat.post(`/api/fispq/extractions/full`, body)
        .then((data) => {
          return resolve(data)
        })
        .catch((error) => {
          return resolve(error.response)
        })
    })
  } catch (error) {
    console.log(error)
  }
}

export const extractChemicalAgentsFispqProduct = async (body) => {
  try {
    return new Promise((resolve, reject) => {
      hoFacilApiChat.post(`/api/fispq/extractions/agents`, body)
        .then((data) => {
          return resolve(data)
        })
        .catch((error) => {
          return resolve(error.response)
        })
    })
  } catch (error) {
    console.log(error)
  }
}

export const rewriteHowWorkerIsExposedToChemicalAgents = async (body) => {
  try {
    return new Promise((resolve, reject) => {
      hoFacilApiChat.post(`/api/permanent-exposure/rewrite`, body)
        .then((data) => {
          return resolve(data)
        })
        .catch((error) => {
          return resolve(error.response)
        })
    })
  } catch (error) {
    console.log(error)
  }
}
